import { PuntoServizioDTO } from '../common/Dtos';
import { Dialog, DialogActions, DialogContent, Table, TableBody, TableContainer } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { HeadCell, Order, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import { SCheckbox, SDialogButton, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import { toast } from 'react-toastify';
import TablePagination from '@material-ui/core/TablePagination';
import AuthContext from '../auth/AuthContext';

interface InserimentoPuntiServizioDialogProps {
	open: boolean;
	onClose: (selected?: string[]) => void;
	alreadyAssociated: PuntoServizioDTO[];
	cooperativa: string;
}

export function InserimentoPuntiServizioDialog(props: InserimentoPuntiServizioDialogProps) {
	const auth = useContext(AuthContext);
	const {onClose, open, alreadyAssociated, cooperativa} = props;
	const [selected, setSelected] = useState<string[]>([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [totalRow, setTotalRow] = useState(0)
	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('name');
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([])

	const headCells: HeadCell[] = [
		{id: 'name', numeric: false, disablePadding: true, label: 'NOME', sortable: true},
		{id: 'cooperativa', numeric: false, disablePadding: true, label: 'COOPERATIVA', sortable: true},
		{id: 'asl', numeric: false, disablePadding: true, label: 'ASL DI COMPETENZA', sortable: true},
		{id: 'indirizzo', numeric: false, disablePadding: true, label: 'INDIRIZZO', sortable: true}
	];

	useEffect(() => {
		getAll();
	}, [orderBy, order, page, rowsPerPage, cooperativa])

	useEffect(() => {
		setSelected([]);
	}, [open]);

	const getAll = () => {
		const qs = require('qs');
		auth.state.axiosInstance?.get('/api/puntoServizio/cooperativa/' + (cooperativa === '' ? auth.state.cooperativa  : cooperativa), {
			params: {
				page: page,
				size: rowsPerPage,
				sort: orderBy + ',' + order
			},
			paramsSerializer: params => {
				return qs.stringify(params)
			}
		})
			.then(res => {
				setPuntiServizioList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dei Punti si Servizio della Cooperativa!');
				console.log(error);
			})
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = puntiServizioList ? puntiServizioList.map(punto => punto.id) : [];
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleCheckBoxClick = (event: React.MouseEvent<unknown>, punto: PuntoServizioDTO) => {
		const selectedIndex = selected.findIndex(u => u === punto.id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, punto.id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const handleConfirmation = () => {
		if (selected && selected.length !== 0) {
			onClose(selected);
		} else {
			toast.error('🛑 Selezionare almeno un operatore!');
		}
	};

	const handleClose = () => {
		onClose();
	};

	const isSelected = (id: string) => selected.findIndex(u => u === id) !== -1;

	const isPresent = (user: PuntoServizioDTO) => alreadyAssociated.findIndex(u => u.id === user.id) !== -1;

	return(
		<Dialog
			fullWidth={true}
			maxWidth="lg"
			open={open}>
			<DialogContent>
				<STitleContainer className="mt-0">
					<STitleH3>Punti di servizio</STitleH3>
				</STitleContainer>
				<TableContainer className="mt-3">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table">
						<STableHeader
							numSelected={selected.length}
							onRequestSort={handleRequestSort}
							onSelectAllClick={handleSelectAllClick}
							order={order}
							orderBy={orderBy}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{puntiServizioList &&
							puntiServizioList
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										!isPresent(row) &&
										<STableRow
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													inputProps={{'aria-labelledby': labelId}}
													onClick={(event) => handleCheckBoxClick(event, row)}
												/>
											</STableCell>
											<STableCell padding="none">{row.name}</STableCell>
											<STableCell padding="none">{row.cooperativaName}</STableCell>
											<STableCell padding="none">{row.asl}</STableCell>
											<STableCell padding="none">{row.indirizzo}</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={totalRow}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
					labelRowsPerPage={"Risultati per pagina"}
				/>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" disabled={!selected || selected.length === 0} onClick={handleConfirmation}>INSERISCI</SDialogButton>
				<SDialogButton className="float-right" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	)
}